@for (announcement of announcements; track announcement) {
  <div>
    @if (canDisplay(announcement)) {
      <div
        class="announcement-banner"
        [ngClass]="getAdditionalCssClasses(announcement)"
        >
        @if (showIcon(announcement)) {
          <mat-icon aria-hidden="false">{{ announcement.icon }}</mat-icon>
        }
        <ng-container
      *ngTemplateOutlet="
        announcementTemplate;
        context: getLanguageSpecificAnnouncement(announcement)
      "
        ></ng-container>
        <ng-template
          #announcementTemplate
          let-message="message"
          let-link="link"
          let-linkText="linkText"
          >
          <div>
            <span class="announcement-banner__message">
              {{ message }}
            </span>
            @if (showLink(announcement)) {
              <a
                class="announcement-banner__link"
                [href]="link"
                target="_blank"
                >
                {{ linkText }}
              </a>
            }
          </div>
        </ng-template>
      </div>
    }
  </div>
}
